'use client';
import { SkeletonLoader } from '@/shared/ui/skeleton/skeleton';
import {
  ListOfWinList,
  ListWrapper,
  Tab,
  TabButton,
  Wrapper,
} from '../../styles';
import { LEADERBOARD_TABS } from '../../model/configs';
import {
  NoLineHeightTabHeader,
  NoLineHeightTitle,
  NoLineHeightWinList,
} from './styles';

const ITEMS_COUNT = 5;
const ITEM_HEIGHT = 60;

export const RecordWinsSkeleton = () => (
  <Wrapper>
    <NoLineHeightTitle>
      <SkeletonLoader width={160} height="100%" />
    </NoLineHeightTitle>

    <Tab>
      {LEADERBOARD_TABS.map((key) => (
        <TabButton key={key} as="div">
          <SkeletonLoader width={64} height={16} />
        </TabButton>
      ))}
    </Tab>

    <ListOfWinList>
      {LEADERBOARD_TABS.map((key) => (
        <ListWrapper key={key}>
          <NoLineHeightTabHeader>
            <SkeletonLoader width={96} height={16} />
          </NoLineHeightTabHeader>
          <NoLineHeightWinList>
            {[...Array(ITEMS_COUNT)].map((_, itemIndex) => (
              <SkeletonLoader
                key={itemIndex}
                width="100%"
                height={ITEM_HEIGHT}
              />
            ))}
          </NoLineHeightWinList>
        </ListWrapper>
      ))}
    </ListOfWinList>
  </Wrapper>
);
